<template>
    <div class="form-container">
        <form @submit.prevent="submitForm">
            <!-- Name Field -->
            <div class="mb-3">
                <label class="form-label">
                    <img src="@/assets/images/social/user.png" class="icos"> {{$t('contact.form.name')}}
                </label>
                <input type="text" class="form-control" v-model="item.name" :placeholder="$t('contact.form.name_placeholder')">
            </div>

            <!-- Phone Field -->
            <div class="mb-3">
                <label class="form-label">
                    <img src="@/assets/images/social/phone_2.png" class="icos"> {{$t('contact.form.phone')}}
                </label>
                <div class="input-group">
                    <select class="form-select" v-model="phoneCode" style="max-width: 180px;">
                        <option v-for="code in phoneCodes" :value="code.code" :key="code.code">
                            {{ code.country }} {{ code.code }}
                        </option>
                    </select>
                    <input type="text" class="form-control" v-model="item.phone" placeholder="0000000000">
                </div>
            </div>

            <!-- Email Field -->
            <div class="mb-3">
                <label class="form-label">
                    <img src="@/assets/images/social/email.png" class="icos"> {{$t('contact.form.email')}}
                </label>
                <input type="email" class="form-control" v-model="item.email" :placeholder="$t('contact.form.email_placeholder')">
            </div>

            <!-- Message Field -->
            <div class="mb-3">
                <label class="form-label">
                    <img src="@/assets/images/social/message_2.png" class="icos"> {{$t('contact.form.message')}}
                </label>
                <textarea class="form-control" v-model="item.content" rows="3" :placeholder="$t('contact.form.message_placeholder')"></textarea>
            </div>

            <!-- Submit Button -->
            <button type="submit" class="btn btn-primary">{{ $t('contact.form.send') }}</button>
        </form>
    </div>
</template>

<script>
import { phoneCodes } from '@/utils';
import Swal from "sweetalert2";
import ContactUs from "../../api/contactus";


export default {
    data() {
        return {
            phoneCodes: phoneCodes,
            phoneCode: phoneCodes[0]?.code || "+966",
            item: {
                name: "",
                phone: "",
                email: "",
                content: ""
            }
        };
    },
    methods: {
        popError(message) {
            Swal.fire({
                position: "top-start",
                icon: "error",
                title: message,
                showConfirmButton: false,
                timer: 3000,
            });
        },
        validateForm() {
            if (!this.item.name.trim()) {
                this.popError(this.$t('contact.errors.name'));
                return false;
            }
            if (!this.item.phone.trim() || isNaN(this.item.phone) ) {
                this.popError(this.$t('contact.errors.phone'));
                return false;
            }
            if (!this.item.email.trim() || !/^\S+@\S+\.\S+$/.test(this.item.email)) {
                this.popError(this.$t('contact.errors.email'));
                return false;
            }
            if (!this.item.content.trim()) {
                this.popError(this.$t('contact.errors.content'));
                return false;
            }
            return true
        },
        async submitForm() {
            if (!this.validateForm()) return;
            let res = await new ContactUs().Insert(this.item);

            if (res.status) {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: this.$t('contact.success'),
                    showConfirmButton: false,
                    timer: 3000,
                });
                this.item = {
                    name: "",
                    phone: "",
                    email: "",
                    content: ""
                }
            } else {
                this.popError(res.message)
            }


        }
    }
};
</script>

<style scoped>
.form-container {
    margin: auto;
}

.input-group-text {
    background: none;
    border: none;
    font-size: 18px;
    color: #BF9F35;
}

.form-control {
    border: 1px solid #6F6D6D40;
}

.icos {
    width: 20px;
    height: auto;
    margin-inline-end: 2px;
}

.btn {
    width: 156px;
}

.form-label {
    font-size: 20px;
    margin-bottom: 12px;
    font-weight: 500;
}
</style>
